import { createIntl as createIntlOriginal, createIntlCache } from 'react-intl';
import { IntlErrorCode } from '@formatjs/intl';
import { translations } from '../../../i18n/utils';
import { BrandText } from '../../music24/components/primitives/BrandWord';
import { keepOneFullStopAfterDates } from '../locale/dateFullStop';

const defaultOnError: Parameters<typeof createIntlOriginal>[0]['onError'] = (err) => {
  if (err.code === IntlErrorCode.MISSING_TRANSLATION) {
    // console.warn('Missing translation', err.message);
    return;
  }
  if (err.code === IntlErrorCode.MISSING_DATA) {
    // console.warn('Missing translation', err.message);
    return;
  }
  console.error(err);
};

export function createIntl({
  locale,
  onError = defaultOnError,
}: {
  locale: string;
  onError?: Parameters<typeof createIntlOriginal>[0]['onError'];
}) {
  const cache = createIntlCache();

  const intl = createIntlOriginal(
    {
      locale,
      messages: translations[locale],
      onError,
      // Every <FormattedMessage> draws "MUSIC24" as the brand word (owner rule 2026-10-23).
      textComponent: BrandText,
    },
    cache
  );
  // A short month such as "nov." at the end of a sentence must not get a second full stop.
  return keepOneFullStopAfterDates(intl);
}
